module.exports = __webpack_public_path__ + "img/logo.3e62a6e1.svg";